module.exports = __webpack_public_path__ + "static/media/office-clerk.b4f44782.jpg";